/**
 * Sorts all arrays together with the first.
 * Pass either a list of arrays, or a map. Any key is accepted.
 *  Array|Object arrays [sortableArray, ...otherArrays]; {sortableArray: [], secondaryArray: [], ...}
 *  Function comparator(?,?) -> int   optional compareFunction, compatible with Array.sort(compareFunction)
 */
const sortArrays = (arrays: any, comparator = (a: any, b: any): number => (a < b) ? -1 : (a > b) ? 1 : 0) => {
  const arrayKeys = Object.keys(arrays);
  const sortableArray = Object.values(arrays)[0] as any[];
  const indexes = Object.keys(sortableArray);
  const sortedIndexes = indexes.sort((a: any, b: any) => comparator(sortableArray[a], sortableArray[b]));

  const sortByIndexes = (array: any[], sortedIndexes: any[]) => sortedIndexes.map(sortedIndex => array[sortedIndex]);

  if (Array.isArray(arrays)) {
    return arrayKeys.map(arrayIndex => sortByIndexes(arrays[Number(arrayIndex)], sortedIndexes));
  } else {
    const sortedArrays: { [key: string]: any; } = {};
    arrayKeys.forEach((arrayKey) => {
      sortedArrays[arrayKey] = sortByIndexes(arrays[arrayKey], sortedIndexes);
    });
    return sortedArrays;
  }
};

export default sortArrays;